import React from 'react';
import './Dropdown.scss';
import clsx from 'clsx';

interface DropdownProps {
  names: React.ReactNode[];
  placeholder: string;
  onChange: (string) => void;
  values?: string[];
  customStyle?: Record<string, any>;
  className?: string;
}

const Dropdown = ({
  names = [],
  placeholder = '',
  onChange = () => {},
  values = [],
  customStyle = {},
  className,
}: DropdownProps) => {
  return (
    <div className="dropdown">
      <div style={customStyle} className="dropdown-button">
        {placeholder}
      </div>
      <div style={customStyle} className={clsx('dropdown-content', className)}>
        {names &&
          names.map((name, i) => (
            <div
              key={`${name}_${i}`}
              className="dropdown-content-button"
              onClick={() => onChange(values.length !== 0 ? values[i] : name)}
            >
              {name}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Dropdown;
